<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <!-- Rail lateral (colapsado) -->
    <nav class="fixed left-0 top-0 z-50 h-full w-16 bg-[#0e1726] text-white flex flex-col items-center shadow-[6px_0_20px_rgba(14,23,38,0.35)]">
        <!-- Logo / Home -->
        <a routerLink="/" class="mt-4 mb-2 flex items-center justify-center">
            <img class="w-8 h-8" src="../../assets/images/logop.png" alt="Pitzon" />
        </a>

        <!-- Botones principales -->
        <ul class="flex-1 mt-2 flex flex-col items-center gap-3">
            <!-- Abrir menú -->
            <li>
                <button (click)="toggleExpanded()" class="h-11 w-11 grid place-content-center rounded-xl bg-white/10 hover:bg-white/20 transition" aria-label="Abrir menú" title="Menú">
                    <icon-menu class="h-5 w-5 text-white" />
                </button>
            </li>
            <li>
                <a routerLink="/profile" class="h-11 w-11 grid place-content-center rounded-xl bg-white/5 hover:bg-white/20 transition" aria-label="Perfil" title="Perfil">
                    <icon-user class="h-5 w-5 text-white" />
                </a>
            </li>
            <li>
                <a routerLink="/manage-vehicles" class="h-11 w-11 grid place-content-center rounded-xl bg-white/5 hover:bg-white/20 transition" aria-label="Vehículos" title="Vehículos">
                    <icon-car class="h-5 w-5 text-white" />
                </a>
            </li>
            <li>
                <a routerLink="/notifications" class="h-11 w-11 grid place-content-center rounded-xl bg-white/5 hover:bg-white/20 transition" aria-label="Notificaciones" title="Notificaciones">
                    <icon-bell class="h-5 w-5 text-white" />
                </a>
            </li>
        </ul>

        <!-- Toggle/Collapse inferior -->
        <div class="mb-4">
            <button (click)="toggleExpanded()" class="h-10 w-10 grid place-content-center rounded-xl bg-white/10 hover:bg-white/20 transition" aria-label="Expandir">
                <span class="block h-4 w-6 rounded-full bg-white/90"></span>
            </button>
        </div>
    </nav>

    <!-- Panel expandible -->
    <aside class="fixed top-0 left-16 z-50 h-full w-[280px] shadow-[10px_0_25px_0_rgba(94,92,154,0.15)] transition-transform duration-300" [ngClass]="isExpanded ? 'translate-x-0' : '-translate-x-[120%]'">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-4 py-4">
                <div class="flex items-center gap-2 text-base font-bold text-[#0e1726] dark:text-white">
                    <icon-wheel class="h-5 w-5 text-[#0e1726] dark:text-white" />
                    <span>Gestionar</span>
                </div>
                <button (click)="toggleExpanded()" class="h-8 w-8 grid place-content-center rounded-full hover:bg-black/5 dark:hover:bg-white/10">
                    <span class="block h-4 w-4 rotate-45 border-2 border-transparent border-t-black border-r-black dark:border-t-white dark:border-r-white"></span>
                </button>
            </div>

            <div class="px-4 pb-2">
                <div class="relative mb-3">
                    <input type="text" placeholder="Buscar vehículo" class="w-full rounded-lg border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/5 px-3 py-2 text-sm text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary" />
                </div>
                <button class="w-full rounded-lg bg-lime-500 text-white text-sm font-semibold py-2 hover:bg-lime-600 transition">+ Agregar vehículo</button>
            </div>

            <ng-scrollbar class="relative !h-[calc(100vh-140px)]" appearance="compact">
                <nav class="px-2 py-2 text-sm font-semibold">
                    <div class="px-2 my-2 text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/50">Perfil</div>
                    <a routerLink="/profile" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-edit class="h-4 w-4" />
                        <span>Editar perfil</span>
                    </a>
                    <a routerLink="/profile" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-share class="h-4 w-4" />
                        <span>Compartir perfil</span>
                    </a>

                    <div class="px-2 mt-4 mb-2 text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/50">Gestionar</div>
                    <a routerLink="/manage-vehicles" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-900 bg-gray-100 dark:bg-white/10 dark:text-white">
                        <icon-car class="h-4 w-4" />
                        <span>Gestionar vehículos</span>
                    </a>
                    <a routerLink="/devices" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-router class="h-4 w-4" />
                        <span>Gestionar dispositivos</span>
                    </a>
                    <a routerLink="/subscriptions" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-credit-card class="h-4 w-4" />
                        <span>Gestión de suscripciones</span>
                    </a>
                    <a routerLink="/preferences" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-settings class="h-4 w-4" />
                        <span>Preferencias</span>
                    </a>

                    <div class="px-2 mt-4 mb-2 text-[11px] uppercase tracking-wide text-gray-400 dark:text-white/50">Cerrar sesión</div>
                    <a routerLink="/contact" class="flex items-center gap-3 rounded-lg px-3 py-2 text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/5">
                        <icon-phone-call class="h-4 w-4" />
                        <span>Contáctanos</span>
                    </a>
                    <a (click)="logout()" class="flex items-center gap-3 rounded-lg px-3 py-2 text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-500/10 cursor-pointer">
                        <icon-logout class="h-4 w-4" />
                        <span>Cerrar sesión</span>
                    </a>
                </nav>
            </ng-scrollbar>
        </div>
    </aside>
</div>
